<template>
    <alert type="danger" :text="text" />
</template>

<script>
import Alert from './Alert.vue';

export default {
    components: { Alert },
    props: {
        text: {
            type: String,
            default: 'Error. Can\'t connect to the platform.'
        }
    },
}
</script>